import messages from '../../messages';

const TIN_NUMBER_REGEX = /^[0-9]{9,10}$/;

const validateRegisterNumber = (value, formatMessage) => {
  let fieldError = '';

  if (!value.trim()) {
    fieldError = formatMessage(messages['empty.register_number.field.error']);
  } else if (!TIN_NUMBER_REGEX.test(value)) {
    fieldError = formatMessage(messages['register_number.validation.message']);
  }

  return fieldError;
};

export default validateRegisterNumber;
